import { Address } from "@redotech/account-common/address";
import { DropoffSearchAddress } from "@redotech/merchant-sdk/rpc/schema/get-dropoff-locations";
import { useRequiredContext } from "@redotech/react-util/context";
import { InteractiveMapLocation } from "@redotech/redo-common-model-location-common/interactive-map-location";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { DropoffProviderType } from "@redotech/redo-return-dropoff-provider-common/dropoff-provider";
import { useQuery } from "@tanstack/react-query";

interface UseDropoffLocationsParams {
  teamId: string;
  provider: DropoffProviderType;
  customerAddress: DropoffSearchAddress;
  merchantAddress: Address;
  enabled: boolean;
}

export function useDropoffLocations({
  teamId,
  provider,
  customerAddress,
  merchantAddress,
  enabled,
}: UseDropoffLocationsParams) {
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);

  return useQuery<InteractiveMapLocation[]>({
    queryKey: [
      "dropoffLocations",
      teamId,
      provider,
      customerAddress,
      merchantAddress,
    ] as const,
    queryFn: async ({ signal }): Promise<InteractiveMapLocation[]> => {
      const { locations } = await rpcClient.getDropoffLocations(
        { teamId, provider, customerAddress, merchantAddress },
        { signal },
      );
      return locations;
    },
    enabled: !!teamId && !!rpcClient && enabled,
    staleTime: Infinity,
  });
}
